import * as p from '@clack/prompts'
import type { EnvTextPromptOptions } from '@cli-types/next-adapter/runtime.js'
import { readNonEmptyEnvVar } from '@cli-utils/files.js'

export async function resolveTextEnvValue(options: EnvTextPromptOptions): Promise<string> {
  const existingValue = readNonEmptyEnvVar(options.cwd, options.key)
  if (existingValue) {
    return existingValue
  }

  const result = await p.text({
    message: options.message,
    defaultValue: options.defaultValue,
    validate: options.validate
  })

  if (p.isCancel(result)) {
    throw new Error(options.cancelMessage)
  }

  options.overwriteEnvKeys.add(options.key)
  return result.trim()
}
